import { render } from "./MainTray.vue?vue&type=template&id=0814ef00"
import script from "./MainTray.vue?vue&type=script&lang=js"
export * from "./MainTray.vue?vue&type=script&lang=js"
script.render = render

export default script